var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAppointments(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 21,
    height: 24,
    fill: "none",
    xmlnsV: "https://vecta.io/nano",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#000"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.908 24h-15a2.5 2.5 0 0 1-1.768-.732A2.5 2.5 0 0 1 .408 21.5v-19a2.5 2.5 0 0 1 2.5-2.5h15a2.5 2.5 0 0 1 2.5 2.5v19a2.5 2.5 0 0 1-.732 1.768 2.5 2.5 0 0 1-1.768.732zm-15-23a1.5 1.5 0 0 0-1.5 1.5v19a1.5 1.5 0 0 0 1.5 1.5h15a1.5 1.5 0 0 0 1.5-1.5v-19a1.5 1.5 0 0 0-1.5-1.5h-15z"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B"
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: -3
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: -6
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: -9
  }), /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#B",
    y: -12
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "B",
    d: "M16.908 19h-13a.5.5 0 0 1-.5-.5.5.5 0 0 1 .5-.5h13a.5.5 0 0 1 .5.5.5.5 0 0 1-.5.5z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppointments);
export default __webpack_public_path__ + "static/media/appointments.e2e5aa10aa8da3cd7f559c3293a1d693.svg";
export { ForwardRef as ReactComponent };